// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DividerWithInfo-module__container__7qeWN{width:100%;display:flex;align-items:center}.DividerWithInfo-module__border__18tUX{border-bottom:1px solid black;width:100%}.DividerWithInfo-module__content__6jUSk{padding:0 10px 0 10px}\n", ""]);
// Exports
exports.locals = {
	"container": "DividerWithInfo-module__container__7qeWN",
	"border": "DividerWithInfo-module__border__18tUX",
	"content": "DividerWithInfo-module__content__6jUSk"
};
module.exports = exports;
